// extracted by mini-css-extract-plugin
module.exports = {"helpful":"reviewHelpfulness_helpful__mvjng","helpfulText":"reviewHelpfulness_helpfulText__yJktT","helpfulButtons":"reviewHelpfulness_helpfulButtons___H8tm"};